module.exports = __webpack_public_path__ + "media/images/smart_phone/icons/order_product_list_search-19aef9dcf502aef6813a57886defc84c.png";